/*
ichitoi2025
@update: 2025/10/31
*/

var page_ready = false;
// ページ読み込み完了後
window.addEventListener('load', ()=>{
    page_ready = true;
});

// slickスライダー
const SLIDER_SELECTOR = '.ec-slickContainer';
const initPromises = [];

// GSAP ScrollTrigger
gsap.registerPlugin(ScrollTrigger);


// スクロール途中位置でブラウザリロードされるとGSAP ScrollTriggerアニメーションが崩れるのでスクロールの自動復元を無効にしておきます。
// 「ScrollTrigger.refresh();」で効果がある場合はそちらが望ましいですが念のため自動復元無効を使います。
if (history.scrollRestoration) {
    //history.scrollRestoration = 'manual';
}

// ブラウザのリサイズ時はGSAPアニメーションを適用か否かの判別も必要なので単純にリロードさせます
$(window).on('jeia_resize', function(){
    window.location.reload();
});



$(function(){

    // slickスライダー生成と初期化完了監視モニタ
    function initializeSlickAndMonitor(sliderElement, slickOptions = {}) {
        return new Promise(resolve => {
            // 'init' イベントリスナーを設定
            $(sliderElement).on('init', function(event, slick) {
                //console.log('Slick初期化完了', sliderElement);
                resolve(); // 初期化完了時にPromiseを解決
            });

            // slickスライダー生成
            $(sliderElement).find(SLIDER_SELECTOR).slick(slickOptions);
        });
    }





    /*
    ------------------------------
    ichitoi2025 function
    */

    if ( page_ready ) {
        init();
    } else {
        window.addEventListener('load', ()=>{
            page_ready = true;
            init();
        });
    }

    // shopifyヘッダー高さ
    var layoutMainPaddingTop;

    // init
    function init() {
        // shopifyヘッダー高さを#MainContentに埋め込まれるstyle要素から取得します
        var $layoutMain = document.querySelector( '#MainContent' );
        layoutMainPaddingTop = parseInt( $layoutMain.style.paddingTop );

        if ( !layoutMainPaddingTop ) {
            // ヘッダー高さが取得できるまでタイマーで監視
            setTimeout(function(){
                layoutMainPaddingTop = parseInt($layoutMain.style.paddingTop);
            }, 300);
        } else {// ヘッダー高さが判定
            // ichitoiプロモーションページの場合
            if ( $('body').hasClass('tpl-page.ichitoi2025-top') ) {
                ichitoi_top1_init();
            }

            // ichitoiイベントページの場合
            if ( $('body').hasClass('tpl-page.ichitoi2025-top2') ) {
                ichitoi_top2_init();
            }
        }
    }

    // ichitoi top init
    function ichitoi_top1_init() {

        // ------------------------------
        // slick初期化

        // セクション: 現在開催中のイベント
        const ichitoiInSession = document.querySelector( '.ichitoiInSessionRole' );
        if (ichitoiInSession) {
            // slickオプション
            const ichitoiInSessionOptions = {
                dots: false,
                slidesToShow: 4,
                //slidesToScroll: 4,
                arrows: true,
                prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="6.91" height="10.991" viewBox="0 0 6.91 10.991"><path d="M4416.736,1263.109l-4.789,4.788,4.789,4.788" transform="translate(-4410.533 -1262.402)" fill="none" stroke-width="2"/></svg></div>',
                nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="6.91" height="10.991" viewBox="0 0 6.91 10.991"><path d="M4411.948,1263.109l4.789,4.788-4.789,4.788" transform="translate(-4411.241 -1262.402)" fill="none" stroke-width="2"/></svg></div>',
                appendArrows:  $(ichitoiInSession).find( '.slick-appendArrows' ),
                responsive: [
                    {
                        breakpoint: 980,// 〇〇px未満
                        settings: {
                            slidesToShow: 3,
                            //slidesToScroll: 3
                        }
                    }
                ]
            };
            // slick生成と監視モニタ
            initPromises.push(initializeSlickAndMonitor(ichitoiInSession, ichitoiInSessionOptions));
        }


        // ------------------------------
        // slickの初期化を待ってGSAPアニメーション初期化を開始
        if (initPromises.length > 0) {
            Promise.all(initPromises)
                .then(() => {
                    //console.log("✅ 全てのSlick構築が完了しました。");
                    initializeGsapAnimations();
                })
                .catch(error => {
                    console.error("Slick初期化中にエラーが発生しました:", error);
                });

        } else {
            // スライダーが存在しない場合はすぐにGSAPを初期化
            initializeGsapAnimations();
        }


        // ------------------------------
        // GSAPアニメーション初期化
        function initializeGsapAnimations() {

            // プロモーションビジュアルの高さをセットして表示開始
            var ichitoiTopPromotionVisual =  document.querySelector('.ichitoiTopPromotionVisualRole');
            $(ichitoiTopPromotionVisual).css( {'height':`calc(100vh - ${layoutMainPaddingTop}px)`} ).addClass( 'is-ready' );

            // サブプロモーション
            var ichitoiTopSubPromotion = document.querySelector('.ichitoiTopSubPromotionRole');
            var ichitoiTopSubPromotionItems = gsap.utils.toArray('.item', ichitoiTopSubPromotion);
            gsap.set(ichitoiTopSubPromotionItems, {opacity: 0});
            gsap.to(
                ichitoiTopSubPromotionItems,
                {
                    opacity: 1,
                    duration: 0.5,
                    stagger: {
                        each: 0.2,
                        from: 'start'
                    },
                    scrollTrigger: {
                        trigger: ichitoiTopSubPromotion,
                        start: 'top 80%',
                        once: true,
                        //markers: true
                    }
                }
            )

            // ichitoiコンテンツブロック
            var ichitoiContentBlocks = gsap.utils.toArray('.ichitoiContentsRole__block2');
            if (ichitoiContentBlocks) {
                ichitoiContentBlocks.forEach((item, index)=>{
                    // アイテムの出現アニメーション
                    gsap.from(
                        item,
                        {
                            y: 300,
                            scale: 0.95,
                            opacity: 0,
                            scrollTrigger: {
                                trigger: item,
                                start: 'top 90%',
                                //end:   'top 70%',
                                //scrub: 1,
                                once: true,
                                //markers: true
                            }
                        }
                    );

                    /*
                    // テキストコンテンツのアニメーション
                    var content = item.querySelector( '.content .inner' );
                    gsap.from(
                        content,
                        {
                            //x: 100,
                            y: 100,
                            opacity: 0,
                            scrollTrigger: {
                                trigger: item,
                                start: 'top 75%',
                                end:   'top 65%',
                                scrub: 1
                            }
                        }
                    );
                    */

                    // 画像のアニメーション
                    var image = item.querySelector( '.image img' );
                    gsap.to(
                        image,
                        {
                            scale: 1.1,
                            scrollTrigger: {
                                trigger: item,
                                start: 'top 50%',
                                end: 'bottom 0%',
                                scrub: 1
                            }
                        }
                    );
                });
            }

            // 現在開催中のイベント
            if (ichitoiInSession) {
                var ichitoiInSessionItems = gsap.utils.toArray( '.item', ichitoiInSession );
                gsap.set(
                    ichitoiInSessionItems,
                    {
                        opacity: 0,
                        scale: 0.8
                    }
                );
                gsap.to(
                    ichitoiInSessionItems,
                    {
                        opacity: 1,
                        scale: 1,
                        duration: 0.5,
                        stagger: {
                            each: 0.15,
                            from: 'start'
                        },
                        scrollTrigger: {
                            trigger: ichitoiInSession,
                            start: 'top 70%',
                            once: true,
                            //markers: true
                        }
                    }
                );
            }

            // レイアウト安定後の最終リフレッシュ
            ScrollTrigger.refresh();
        }
    }


    // ichitoi top2 init
    function ichitoi_top2_init() {

        // ------------------------------
        // slick初期化

        // セクション：ピックアップスライダー
        const ichitoiPickUpSlider = document.querySelector( '.ichitoiPickUpSliderRole' );
        if (ichitoiPickUpSlider) {
            // slickオプション
            const ichitoiPickUpSliderOptions = {
                dots: false,
                slidesToShow: 3,
                //slidesToScroll: 3,
                centerMode: true,
                centerPadding: "0%",
                arrows: true,
                prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="6.91" height="10.991" viewBox="0 0 6.91 10.991"><path d="M4416.736,1263.109l-4.789,4.788,4.789,4.788" transform="translate(-4410.533 -1262.402)" fill="none" stroke-width="2"/></svg></div>',
                nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="6.91" height="10.991" viewBox="0 0 6.91 10.991"><path d="M4411.948,1263.109l4.789,4.788-4.789,4.788" transform="translate(-4411.241 -1262.402)" fill="none" stroke-width="2"/></svg></div>',
                appendArrows:  $(ichitoiPickUpSlider).find( '.slick-appendArrows' ),
                responsive: [
                    {
                        breakpoint: 980,// 〇〇px未満
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
            // slick生成と監視モニタ
            initPromises.push(initializeSlickAndMonitor(ichitoiPickUpSlider, ichitoiPickUpSliderOptions));
        }

        // セクション: 一十一アーカイブ
        const ichitoiCollectionArchive = document.querySelector( '.ichitoiCollectionArchiveRole' );
        if (ichitoiCollectionArchive) {
            // slickオプション
            const ichitoiCollectionArchiveOptions = {
                dots: false,
                slidesToShow: 4,
                //slidesToScroll: 4,
                arrows: true,
                prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="6.91" height="10.991" viewBox="0 0 6.91 10.991"><path d="M4416.736,1263.109l-4.789,4.788,4.789,4.788" transform="translate(-4410.533 -1262.402)" fill="none" stroke-width="2"/></svg></div>',
                nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="6.91" height="10.991" viewBox="0 0 6.91 10.991"><path d="M4411.948,1263.109l4.789,4.788-4.789,4.788" transform="translate(-4411.241 -1262.402)" fill="none" stroke-width="2"/></svg></div>',
                appendArrows:  $(ichitoiCollectionArchive).find( '.slick-appendArrows' ),
                responsive: [
                    {
                        breakpoint: 1279,// 〇〇px未満
                        settings: {
                            slidesToShow: 3,
                            //slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 980,// 〇〇px未満
                        settings: {
                            slidesToShow: 3,
                            //slidesToScroll: 3
                        }
                    }
                ]
            };
            // slick生成と監視モニタ
            initPromises.push(initializeSlickAndMonitor(ichitoiCollectionArchive, ichitoiCollectionArchiveOptions));
        }


        // ------------------------------
        // slickの初期化を待ってGSAPアニメーション初期化を開始
        if (initPromises.length > 0) {
            Promise.all(initPromises)
                .then(() => {
                    //console.log("✅ 全てのSlick構築が完了しました。");
                    initializeGsapAnimations();
                })
                .catch(error => {
                    console.error("Slick初期化中にエラーが発生しました:", error);
                });

        } else {
            // スライダーが存在しない場合はすぐにGSAPを初期化
            initializeGsapAnimations();
        }


        // ------------------------------
        // GSAPアニメーション初期化
        function initializeGsapAnimations() {

            // EVENT/WORKSHOP
            var ichitoiCollectionEvent = document.querySelector( '.ichitoiCollectionEventRole' );
            if (ichitoiCollectionEvent) {
                var ichitoiCollectionEventItems = gsap.utils.toArray( '.item', ichitoiCollectionEvent );
                gsap.set(
                    ichitoiCollectionEventItems,
                    {
                        opacity: 0,
                        scale: 0.8
                    }
                );
                gsap.to(
                    ichitoiCollectionEventItems,
                    {
                        opacity: 1,
                        scale: 1,
                        duration: 0.5,
                        stagger: {
                            each: 0.15,
                            from: 'start'
                        },
                        scrollTrigger: {
                            trigger: ichitoiCollectionEvent,
                            start: 'top 50%',
                            once: true,
                            //markers: true
                        }
                    }
                );
            }

            // EVENT/ARCHIVE
            if (ichitoiCollectionArchive) {
                var ichitoiCollectionArchiveItems = gsap.utils.toArray( '.item', ichitoiCollectionArchive );
                gsap.set(
                    ichitoiCollectionArchiveItems,
                    {
                        opacity: 0,
                        scale: 0.8
                    }
                );
                gsap.to(
                    ichitoiCollectionArchiveItems,
                    {
                        opacity: 1,
                        scale: 1,
                        duration: 0.5,
                        stagger: {
                            each: 0.15,
                            from: 'start'
                        },
                        scrollTrigger: {
                            trigger: ichitoiCollectionArchive,
                            start: 'top 70%',
                            once: true,
                            //markers: true
                        }
                    }
                );
            }

            // 一十一コラム
            var ichitoiColumn = document.querySelector( '.ichitoiColumnRole' );
            if (ichitoiColumn) {
                var ichitoiColumnCards = gsap.utils.toArray( '.card', ichitoiColumn );
                gsap.set(
                    ichitoiColumnCards,
                    {
                        opacity: 0,
                        scale: 0.8
                    }
                );
                gsap.to(
                    ichitoiColumnCards,
                    {
                        opacity: 1,
                        scale: 1,
                        duration: 0.5,
                        stagger: {
                            each: 0.15,
                            from: 'start'
                        },
                        scrollTrigger: {
                            trigger: ichitoiColumn,
                            start: 'top 50%',
                            once: true,
                            //markers: true
                        }
                    }
                );
            }

            // フッターコンテンツBlock1
            var ichitoiBottomContentBlock1 = document.querySelector( '.ichitoiBottomContentRole__block1' );
            if (ichitoiBottomContentBlock1) {
                var ichitoiBottomContentBlock1Items = gsap.utils.toArray( '.item', ichitoiBottomContentBlock1 );
                gsap.set(
                    ichitoiBottomContentBlock1Items,
                    {
                        y: 100,
                        opacity: 0,
                        visibility: 'hidden'
                    }
                );
                gsap.to(
                    ichitoiBottomContentBlock1Items,
                    {
                        y: 0,
                        opacity: 1,
                        visibility: 'visible',
                        duration: 0.8,
                        stagger: {
                            each: 0.1,
                            from: 'random'
                        },
                        scrollTrigger: {
                            trigger: ichitoiBottomContentBlock1,
                            start: 'top 70%',
                            once: true,
                            //markers: true
                        }
                    }
                );
            }

            // レイアウト安定後の最終リフレッシュ
            ScrollTrigger.refresh();
        }
    }



    // その他のfunction


    // jeia_resize リサイズイベント
    /**
     * iOS Safariの場合、メニューバー・アドレスバーが折りたたまれる度にresizeイベントが発火してしまいます。
     * カスタムイベントとして「jeia_resize」を準備します。こちらは基本、横幅が変化した場合にのみ発火するようにしています。
     */
    // スマホでの不要なresizeイベント発火を防ぐためブラウザ幅を記憶
    var initial_window_width = window.innerWidth;
    var resize_timer = false;
    $(window).on('resize', function(){
        if ( resize_timer !== false ) {
            clearTimeout( resize_timer );
        }
        resize_timer = setTimeout(function(){

            if ( initial_window_width != window.innerWidth ) {
                // 記憶ブラウザ幅更新
                initial_window_width = window.innerWidth;
                // jeia_resizeイベントを発火
                $(window).trigger( 'jeia_resize' );
            }
        }, 100);
    });

    // スマホ・タブレット時は一応、orientationchangeイベントでjeia_resizeを発火
    $(window).on('orientationchange', function(){
        $(window).trigger( 'jeia_resize' );
    });


    // ブロックを表示領域に入ったらふわりと表示
    if ( "IntersectionObserver" in window ) {

        // Intersection obsererの作成
        let options = {
            root: null,
            // 各ターゲット要素の高さはそれぞれなので、閾値thresholdは0としておき、rootMarginで一律固定量がブラウザ表示領域に入ったらとします
            rootMargin: '-25% 0px',
            threshold: 0
        };
        let appearEffectObserver = new IntersectionObserver( appearCheck, options );

        function appearCheck( entries, observer ) {
            //console.log('appearCheck', entries, observer);
            entries.forEach(function( entry ) {
                if ( entry.isIntersecting ) {
                    let $entryTarget = $( entry.target );
                    //console.log('appearCheck - IN', $entryTarget);
                    if ( $entryTarget.hasClass('appearEffectCustom') ) {
                        $entryTarget.addClass( 'is-appearCustom' );
                    } else {
                        $entryTarget.addClass( 'is-appear' );
                    }
                    observer.unobserve( entry.target );
                }
            });
        }

        // 監視される要素ターゲット
        var targets = [].slice.call(document.querySelectorAll( '.appearEffect, .appearEffectCustom' ));
        targets.forEach(function( entryTarget ) {
            appearEffectObserver.observe( entryTarget );
        });

    } else {
        // IE11ではサポートされません
        //console.log('Intersection Observer APIがありません');
        $( '.appearEffect' ).addClass( 'is-appear' );
        $( '.appearEffectCustom' ).addClass( 'is-appearCustom' );
    }

});